import { GET_ALL_LOGIN_DETAILS, RECEIVE_POSTS } from "./ActionTypes";
const INITIAL_STATE = {
    otpReceived: false,
    otpCode: '',
    otpVerified: false,
    countryCode: '+91',
    userObj: null,
    cnbcActive: false
};
const LoginReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RECEIVE_POSTS:
            return { ...state, json: action.json };
        case GET_ALL_LOGIN_DETAILS:

            return {
                ...state,
                loginList: action.payload,

            };
        default:
            return state
    }
};
export default LoginReducer